import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StoryblokIcon } from "@cinch-nx/landing-ui-shared";
import styles from "./ev-benefits.module.css";
import sharedStyles from "../../landing-feature-electric-cars.module.css";
const BenefitCard = ({ benefit  })=>{
    const { icon , title , text  } = benefit;
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.cardContainer,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.iconContainer,
                children: /*#__PURE__*/ _jsx(StoryblokIcon, {
                    iconName: icon,
                    size: 24
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.textContainer,
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        className: styles.title,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.text,
                        children: text
                    })
                ]
            })
        ]
    });
};
export const EvBenefits = ({ evBenefits  })=>/*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: sharedStyles.heading,
                children: "Benefits of an electric car"
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.cardList,
                children: evBenefits.map((benefit)=>/*#__PURE__*/ _jsx(BenefitCard, {
                        benefit: benefit
                    }, `benefit-${benefit.title}`))
            })
        ]
    });
